import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad3Actividad7.mp3";

const Actividad9 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "1" },
    ans2: { value: "", valid: "", correctValue: "1" },
    ans3: { value: "", valid: "", correctValue: "1" },
    ans4: { value: "", valid: "", correctValue: "0" },
  });
  const infoUnidad = modulo12.content[2];
  const infoAct = modulo12.content[2].activities[8];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titlePrev: `${modulo12.content[2].name}: ${modulo12.content[2].activities[7].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[7].path}`,
    titleNext: `${modulo12.content[2].name}: ${modulo12.content[2].activities[9].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[9].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  const handleAnswers = (event, name) => {
    if (answers[name]["value"] === event.target.value) {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: "2" },
      });
    } else {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: event.target.value },
      });
    }
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-lg-10 col-12 p-0">
          <ul>
            <li>Trabaja con un compañero, compañera o familiar</li>
            <li>
              Coloquen un check a las ideas que les parecen correctas. Deben
              ponerse de acuerdo entre los dos.
            </li>
            <li>Comenta por qué les parecen correctas estas ideas.</li>
          </ul>
        </div>
      </div>
      <div>
        <div className="d-flex align-items-center">
          <input
            className={"form-check-input me-1 form-md " + answers.ans1.valid}
            type="checkbox"
            value="1"
            checked={answers.ans1.value === "1"}
            onChange={(event) => handleAnswers(event, "ans1")}
          />
          <div>Las mujeres deben quedarse en casa para criar a los hijos.</div>
        </div>
        <div className="d-flex align-items-center">
          <input
            className={"form-check-input me-1 form-md " + answers.ans2.valid}
            type="checkbox"
            value="1"
            checked={answers.ans2.value === "1"}
            onChange={(event) => handleAnswers(event, "ans2")}
          />
          <div>Los hombres y las mujeres pueden hacer los mismos trabajos.</div>
        </div>
        <div className="d-flex align-items-center">
          <input
            className={"form-check-input me-1 form-md " + answers.ans3.valid}
            type="checkbox"
            value="1"
            checked={answers.ans3.value === "1"}
            onChange={(event) => handleAnswers(event, "ans3")}
          />
          <div>
            No debe haber bomberas ni ingenieras: eso es para gente fuerte.
          </div>
        </div>
        <div className="d-flex align-items-center">
          <input
            className={"form-check-input me-1 form-md " + answers.ans4.valid}
            type="checkbox"
            value="1"
            checked={answers.ans4.value === "1"}
            onChange={(event) => handleAnswers(event, "ans4")}
          />
          <div>En una discusión, los hombres tienen la razón.</div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea la primera y la segunda indicación: Trabaja con un compañero,
            compañera o familiar. Coloquen un check a las ideas que les parecen
            correctas. Deben ponerse de acuerdo entre los dos. Pida a un
            estudiante que lea en voz alta las ideas que aparecen en los
            rectángulos. Lea la última indicación: Comenta por qué les parecen
            correctas estas ideas. Explique que deben ponerse de acuerdo sobre
            qué idea o ideas les parecen adecuadas y marcarlas. En segundo
            lugar, deben explicar por qué les parecen adecuadas y, por último,
            deben explicar por qué descartaron las otras ideas. Déles un tiempo
            para que trabajen. Retome algunas respuestas. Deténgase en cada idea
            y explique por qué es o no válida. Tenga en cuenta que la única idea
            que no es discriminatoria y que ubica a la mujer en una situación de
            igualdad con los hombres es la segunda. Usted debe ayudar a
            identificar los elementos de discriminación en las otras ideas.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
